import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-activity-competition",
  "use": "icon-activity-competition-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-activity-competition\"><defs><style type=\"text/css\"></style></defs><path d=\"M929.85 726.8l-51.07 51.06-87.74-87.74 90.33-90.33-50.25-50.25-90.33 90.33-60.3 60.31-90.34 90.33 50.25 50.25 90.34-90.33 87.74 87.74-51.07 51.07 30.15 30.15L960 756.95zM191.25 304.76l219.52 177.38-91.57 113.32 68.57 68.57 124-100.28 124.29 100.43 68.57-68.57-91.83-113.56 219.69-177.67a56.82 56.82 0 0 0 20.41-35.36l25.89-164.41-164.67 25.59a56.853 56.853 0 0 0-35.49 20.45l-166.86 206.5-166.78-206.24a56.847 56.847 0 0 0-35.36-20.41l-164.4-25.89 25.58 164.66a56.795 56.795 0 0 0 20.44 35.49zM283.21 639.88l-90.33-90.34-50.25 50.25 90.33 90.34-87.74 87.74-51.07-51.07L64 756.95l162.44 162.44 30.15-30.15-51.06-51.07 87.74-87.74 90.33 90.33 50.25-50.25-90.33-90.33z\" p-id=\"4436\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/activity-competition.svg
// module id = /lmF
// module chunks = 115